import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../config/api";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../../components/private/pagination";

const InformacionGeneral = () => {

  const { token, authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [informacion, setInformacion] = useState([]);
  const [loading, setLoading] = useState(true);

  // =========================================
  // FILTROS
  // =========================================

  const [contratoFilter, setContratoFilter] = useState("");
  const [contratanteFilter, setContratanteFilter] = useState("");
  const [fechaInicioFilter, setFechaInicioFilter] = useState("");

  // =========================================
  // PAGINACIÓN
  // =========================================

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // =========================================
  // CARGAR INFORMACIÓN
  // =========================================

  useEffect(() => {

    if (!token) return;

    const loadInformacion = async () => {

      setLoading(true);

      try {

        const data = await authFetch(
          ENDPOINTS.getInformacionGeneral
        );

        if (data.success && data.data) {

          setInformacion(data.data);

        } else {

          setInformacion([]);

        }

      } catch (error) {

        console.error(
          "Error cargando información general:",
          error
        );

        setInformacion([]);

      }

      setLoading(false);

    };

    loadInformacion();

  }, [token, authFetch]);

  // =========================================
  // FILTROS
  // =========================================

  const filteredInformacion = informacion.filter((item) => {

    const matchesContrato =

      contratoFilter === "" ||

      item.contrato_convenio
        ?.toLowerCase()
        .includes(contratoFilter.toLowerCase());

    const matchesContratante =

      contratanteFilter === "" ||

      item.contratante
        ?.toLowerCase()
        .includes(contratanteFilter.toLowerCase());

    const matchesFecha =

      fechaInicioFilter === "" ||

      item.fecha_inicio >= fechaInicioFilter;

    return (
      matchesContrato &&
      matchesContratante &&
      matchesFecha
    );

  });

  // =========================================
  // PAGINACIÓN
  // =========================================

  const totalPages = Math.ceil(
    filteredInformacion.length / recordsPerPage
  );

  const currentInformacion = filteredInformacion.slice(

    (currentPage - 1) * recordsPerPage,

    currentPage * recordsPerPage

  );

  const goToPage = (page) => {

    if (page >= 1 && page <= totalPages) {

      setCurrentPage(page);

    }

  };

  // =========================================
  // LOADING
  // =========================================

  if (loading) {

    return <p>Cargando información general...</p>;

  }

  // =========================================
  // RENDER
  // =========================================

  return (

    <div className="container mt-4 p-4">

      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center mb-3">

        <h2>Información General</h2>

        <button
          className="btn btn-outline-pink"
          onClick={() =>
            navigate(
              "/session/mod_administrativa/informacion_general/create_informacion_general"
            )
          }
        >
          <i className="bi bi-plus-circle me-1"></i>

          Crear Información

        </button>

      </div>

      {/* FILTROS */}

      <div className="row mb-3">

        <div className="col-md-4">

          <label className="m-1">
            Contrato / Convenio
          </label>

          <input
            type="text"
            className="form-control"
            value={contratoFilter}
            onChange={(e) => {

              setContratoFilter(e.target.value);
              setCurrentPage(1);

            }}
          />

        </div>

        <div className="col-md-4">

          <label className="m-1">
            Contratante
          </label>

          <input
            type="text"
            className="form-control"
            value={contratanteFilter}
            onChange={(e) => {

              setContratanteFilter(e.target.value);
              setCurrentPage(1);

            }}
          />

        </div>

        <div className="col-md-4">

          <label className="m-1">
            Fecha inicio
          </label>

          <input
            type="date"
            className="form-control"
            value={fechaInicioFilter}
            onChange={(e) => {

              setFechaInicioFilter(e.target.value);
              setCurrentPage(1);

            }}
          />

        </div>

      </div>

      {/* TABLA */}

      {currentInformacion.length > 0 ? (

        <>

          <table className="table table-hover">

            <thead className="table-secondary">

              <tr>

                <th>Contrato</th>
                <th>Contratante</th>
                <th>Objeto</th>
                <th>Inicio</th>
                <th>Fin</th>
                <th>Valor</th>
                <th>Acciones</th>

              </tr>

            </thead>

            <tbody>

              {currentInformacion.map((item) => (

                <tr key={item.id}>

                  <td>
                    {item.contrato_convenio}
                  </td>

                  <td>
                    {item.contratante}
                  </td>

                  <td>
                    {item.objeto}
                  </td>

                  <td>
                    {item.fecha_inicio}
                  </td>

                  <td>
                    {item.fecha_fin}
                  </td>

                  <td>

                    {Number(
                      item.valor_contrato_antes_iva
                    ).toLocaleString()}

                  </td>

                  <td>

                    <button
                      className="btn btn-sm btn-secondary m-1"
                      onClick={() =>
                        navigate(
                          `/session/mod_proyectos/informacion_general/viewInformacionGeneral/${item.id}`
                        )
                      }
                    >
                      <i className="bi bi-eye">
                        {" "}Detalle
                      </i>
                    </button>

                    <button
                      className="btn btn-sm btn-outline-purple"
                      onClick={() =>
                        navigate(
                          `/session/mod_proyectos/informacion_general/updateInformacionGeneral/${item.id}`
                        )
                      }
                    >
                      <i className="bi bi-pencil-square me-1">
                        {" "}Modificar
                      </i>
                    </button>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

          {/* PAGINACIÓN */}

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />

        </>

      ) : (

        <p>
          No hay información general registrada.
        </p>

      )}

    </div>

  );

};

export default InformacionGeneral;